import styles from './Column.module.scss'

const Column = ({ children, title, subtitle, isFullWidth }) => (
  <div className={[styles.container, isFullWidth ? styles.fullWidth : ''].join(' ')}>
    <p className={styles.title}>{title}</p>
    {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
    <div className={styles.column}>{children}</div>
  </div>
)

export const ColumnFooter = ({ children }) => (
  <div className={styles.footer}>{children}</div>
)

export const ColumnWarning = ({ children }) => (
  <div className={styles.warning}>{children}</div>
)

export default Column
